import { render, staticRenderFns } from "./StoredList.vue?vue&type=template&id=524db896&"
import script from "./StoredList.vue?vue&type=script&lang=js&"
export * from "./StoredList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports